import React, { useState, useEffect } from "react";
import { ChangeEvent } from "react";
import useForm from "../Hooks/useForm";
import Input from "../FormUi/Input";
import { isNumber } from "lodash";
import "../../css/Global.css";

import { Field } from "../Types/Form";

import PhoneValidate from "./PhoneValidate";
import EmailValidate from "./EmailValidate";


const phoneFieldNames = ["phone", "phon", "number", "phonenumber", "usernumber", "userphone"];
const emailFieldNames = ["email", "gmail", "mail", "useremail", "usergmail", "usermail", "accountmail", "accountemail"];

type props = {
    field: Field;
    value: any;
}
 
const Validation = ({field, value}: props) => {
    const { name, element } = field;

    let validate = () => {
        if (field?.validate) return field.validate(value);
        if (element && element == "select") return !value;
        if (element && element == "checkbox") return !value;
        if (element && element == "calendar") return !value;
        if (phoneFieldNames.some(item => name.toLowerCase()?.trim().includes(item))) return PhoneValidate(value);
        if (emailFieldNames.some(item => name.toLowerCase()?.trim().includes(item))) return EmailValidate(value);
        return !value?.trim();
    }

    let error = () => {
        if (field?.error) return field.error;
        if (element && element == "select") return "Выберите элемент из списка";
        if (element && element == "checkbox") return "Подтвердите согласие";
        if (element && element == "calendar") return "Заполните дату";
        if (phoneFieldNames.some(item => name.toLowerCase()?.trim().includes(item))) return "Некорректный телефон";
        if (emailFieldNames.some(item => name.toLowerCase()?.trim().includes(item))) return "Некорректная почта";
        return "Заполните поле";
    }

    if (validate()) return error();

    return "";
}

export default Validation;